import PlayerService from '../services/player';
import { useFastActions } from './fastActions';
import { useFullscreenActions } from './fullscreen';
import { usePiPActions } from './pip';
import { usePlaybackRateActions } from './playbackRate';
import { usePlayPauseActions } from './playPause';
import { useSeekAction } from './seek';
import { useVolumeActions } from './volume';

type IUseVideoActionsInput = {
  playerService: React.MutableRefObject<PlayerService>;
  videoElementRef: React.MutableRefObject<HTMLVideoElement | null>;
  isFullscreenOptionEnabledForCustomPlayer: boolean;
  areMuteUnmuteOptionsEnabledForCustomPlayer: boolean;
  isPlaybackRateOptionEnabledForCustomPlayer: boolean;
  isSkipForwardEnabledForCustomPlayer: boolean;
  isSkipBackwardsEnabledForCustomPlayer: boolean;
};

export const useVideoActions = ({
  playerService,
  videoElementRef,
  isFullscreenOptionEnabledForCustomPlayer,
  areMuteUnmuteOptionsEnabledForCustomPlayer,
  isPlaybackRateOptionEnabledForCustomPlayer,
  isSkipForwardEnabledForCustomPlayer,
  isSkipBackwardsEnabledForCustomPlayer,
}: IUseVideoActionsInput) => {
  usePlayPauseActions(playerService);
  useFullscreenActions(isFullscreenOptionEnabledForCustomPlayer);
  useSeekAction(playerService);
  usePiPActions(videoElementRef);
  useVolumeActions(playerService, areMuteUnmuteOptionsEnabledForCustomPlayer);
  usePlaybackRateActions(videoElementRef, isPlaybackRateOptionEnabledForCustomPlayer);
  useFastActions(playerService,
    isSkipForwardEnabledForCustomPlayer,
    isSkipBackwardsEnabledForCustomPlayer
  );
}
